module.exports = __webpack_public_path__ + "img/xp1.857deb75.jpg";